export default __webpack_public_path__ + "static/screeny-110-gpz-unica-am-scheda-tecnica-8b06108c3a6e3e627fe91bcafbb4eefa.pdf";